import intl from 'react-intl-universal'
import zhCN from 'antd/locale/zh_CN'
// import enUS from 'antd/locale/en_US'

// 支持的语言
export const SUPPOER_LOCALES = [
  {
    name: 'English',
    value: 'en-US'
  },
  {
    name: '简体中文',
    value: 'zh-CN'
  }
]
// 当前选择的语言
export const currentLocale = (() => {
  let locale = localStorage.getItem('lang') || 'zh-CN'
  if (!SUPPOER_LOCALES.find(item => item.value === locale)) {
    locale = 'en-US'
  }
  return locale
})()

// const requireCtx = require.context('./', true, /[^/.]+\/index\.js$/)
// const locales = {}
// requireCtx.keys().forEach(relPath => {
//   const dirName = relPath.match(/([^/.]+)\/index\.js$/)[1]
//   locales[dirName] = requireCtx(relPath).default || requireCtx(relPath)
// })
const requireCtx = require.context('./', true, /[^/.]+\/(en-US|zh-CN)\.js$/)
const locales = {}
requireCtx.keys().forEach(relPath => {
  const match = relPath.match(/([^/.]+)\/(en-US|zh-CN)\.js$/)
  if (match) {
    const moduleName = match[1]
    const language = match[2]

    // 确保语言对象存在
    if (!locales[language]) {
      locales[language] = {}
    }

    const moduleData = requireCtx(relPath).default || requireCtx(relPath)
    // 将模块数据合并到对应语言中，使用 moduleName 作为前缀
    Object.keys(moduleData).forEach(key => {
      locales[language][`${moduleName}.${key}`] = moduleData[key]
    })
  }
})

console.log(locales)
// 加载语言包并初始化
let loadedLocales
export const loadLocales = language => {
  // TODO: 替换为线上请求和localStorage读取
  return new Promise((resolve) => {
    resolve(locales)
  }).then((data) => {
    loadedLocales = data
  }).catch(() => {
    loadedLocales = locales
  }).finally(() => {
    if (language) {
      return intl.init({
        currentLocale: language,
        locales: loadedLocales
      })
    }
    return intl.init({
      currentLocale: language || currentLocale,
      locales: loadedLocales
    })
  })
}
export const translate = (...args) => {
  return intl.get(...args)
}


export const antdLocale = zhCN
